import * as React from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"
import Container from "../components/container/container"
import { graphql, Link } from "gatsby"
import * as styles from "../components/case-study/study.module.scss"
import Markdown from "react-markdown"

export const query = graphql`
  {
    strapiCaseStudiesList {
      Heading
      Seo {
        metaTitle
        metaDescription
        keywords
      }
    }
    allStrapiCaseStudies {
      edges {
        node {
          Heading
          Summary
          Slug
          BackgroundImage {
            publicURL
          }
        }
      }
    }
  }
`

const CaseStudiesListPage = ({ data }) => (
  <Layout slug={`/case-studies`}>
    <Seo
      title={data.strapiCaseStudiesList.Seo.metaTitle}
      description={data.strapiCaseStudiesList.Seo.metaDescription}
      keywords={data.strapiCaseStudiesList.Seo.keywords}
    />
    <div className={styles.study}>
      <div className={styles.study__banner}>
        <Container>
          <h1>{data.strapiCaseStudiesList.Heading}</h1>
        </Container>
      </div>
      <div>
        <Container>
          <div className={`${styles.study__studies} d-flex align-items-center`}>
            {data.allStrapiCaseStudies.edges.map((study, key) => (
              // <div className={styles.study__studies__study} key={key}>
              //   <p class={styles.study__studies__study__heading}>
              //     {study.node.Heading}
              //   </p>
              //   <Markdown>{study.node.Summary}</Markdown>
              //   <Link to={`/case-studies/${study.node.Slug}`} className="cta">
              //     Read More
              //   </Link>
              // </div>
              <div
                className={styles.study__studies__study}
                key={key}
                style={{
                  backgroundImage: `url('${study.node.BackgroundImage.publicURL}')`,
                }}
              >
                <div className={styles.study__studies__study__overlay}></div>
                <div className={styles.study__studies__study__content}>
                  <p class={styles.study__studies__study__heading}>
                    {study.node.Heading}
                  </p>
                  <Markdown>{study.node.Summary}</Markdown>
                  <Link to={`/case-studies/${study.node.Slug}`} className="cta">
                    Read More
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </Container>
      </div>
    </div>
  </Layout>
)

export default CaseStudiesListPage
